<script>
  // @ts-check
  import { createEventDispatcher } from "svelte";
  import Checkbox from "./Checkbox.svelte";

  /** The list of radio buttons to display
   * @type {Array<{label: string; id: string; isChecked: boolean}>} */
  export let options;

  /** The name of the checkbox group
   * @type {string} */
  export let name;

  /**
   * An optional CSS class to be applied to the component.
   * @type {string}
   */
  export let componentClass = "";

  const dispatch = createEventDispatcher();
  function handleChange(checkbox) {
    const { detail } = checkbox;

    options = options.map((option) => {
      if (option.id === detail.id) {
        option.isChecked = detail.value;
      }
      return option;
    });

    dispatch("checkBoxSelectionGroup", { options, name });
  }
</script>

<div class="flex w-full flex-col gap-6 {componentClass}" id={name}>
  {#each options as option}
    <Checkbox {...option} on:change={handleChange} />
  {/each}
</div>
